module.exports = __webpack_public_path__ + "static/During Work - 1-03d93dfff477379b8f36d0f540450149.jpg";